import getLang from 'I18n/utils/getLang';
import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import * as coreMiddlewares from 'hub-http/middlewares/core';
import appAuthStack from 'hub-http/stacks/hubapi';
import noAuthStack from 'hub-http/stacks/noAuthWithCredentialsHubapi';
import { apiClientProvider } from '../utils/apiClient';
let marketplaceSearchBase = 'marketplace-search/v1';
export const marketplaceSearchAppClient = promiseClient(createStack(coreMiddlewares.base('marketplace-search/v1/'), appAuthStack));
export const marketplaceSearchPublicClient = promiseClient(createStack(coreMiddlewares.base('marketplace-search/public/v1/'), noAuthStack));
export function getMarketplaceSearchClient(appContext) {
  switch (appContext) {
    case 'public':
      return marketplaceSearchPublicClient;
    default:
      return marketplaceSearchAppClient;
  }
}
export const setMarketplaceSearchBase = base => {
  marketplaceSearchBase = base;
};
export const marketplaceSearchProfiles = apiClientProvider((apiClient, query) => {
  // Extend timeout for requests, especially important for Australia region
  const requestOptions = {
    data: [Object.assign({}, query, {
      callingUserLanguage: getLang()
    })],
    timeout: 30000 // 30 seconds timeout
  };
  return apiClient.post(`${marketplaceSearchBase}/profiles/search`, requestOptions);
});
export const marketplaceSearchProfilesMulti = apiClientProvider((apiClient, queries) => {
  // Apply same extended timeout for multi-profile search
  const requestOptions = {
    data: queries,
    timeout: 30000 // 30 seconds timeout
  };
  return apiClient.post(`${marketplaceSearchBase}/profiles/search`, requestOptions);
});